import { Injectable } from '@angular/core';
import { ContentListFilterValues } from 'src/app/content-list-management/content-lists/i-content-list-filter-values';

@Injectable({
  providedIn: 'root',
})
export class ContentListFilterService {
  public getFilters(): ContentListFilterValues {
    const name = localStorage.getItem('content-list-filter-name') || '';
    const website = localStorage.getItem('content-list-filter-website') || '';
    const contentListType =
      localStorage.getItem('content-list-filter-contentlisttype') || '';
    const time = localStorage.getItem('content-list-filter-time') || 5;

    return new ContentListFilterValues(
      name,
      website,
      contentListType,
      Number(time),
    );
  }

  public setFilters(filters: ContentListFilterValues) {
    localStorage.setItem('content-list-filter-name', filters.name);
    localStorage.setItem('content-list-filter-website', filters.website);
    localStorage.setItem(
      'content-list-filter-contentlisttype',
      filters.contentListType,
    );
    localStorage.setItem('content-list-filter-time', String(filters.time));
  }

  public defaultFilters() {
    localStorage.setItem('content-list-filter-name', '');
    localStorage.setItem('content-list-filter-website', '');
    localStorage.setItem('content-list-filter-contentlisttype', '');
    localStorage.setItem('content-list-filter-time', '5');
  }
}
